import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, LogOut, User, Mail, Clock } from 'lucide-react';
import { useAdminAuth } from '../../admin/AdminAuthContext';
import { toast } from 'sonner';
import dayjs from 'dayjs';

export default function AdminSettingsPage() {
  const navigate = useNavigate();
  const { admin, logout } = useAdminAuth();

  const handleLogout = () => {
    logout();
    toast.info('Logged out');
    navigate('/admin/login');
  };

  return (
    <div data-testid="admin-settings-page" className="max-w-2xl">
      <h1 className="text-xl font-black text-gray-900 mb-4">Settings</h1>

      <div className="bg-white rounded-xl border border-gray-200 p-5">
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 rounded-full bg-brand-magenta flex items-center justify-center flex-shrink-0">
            <Shield className="w-7 h-7 text-white" />
          </div>
          <div className="flex-1">
            <h2 className="text-lg font-black text-gray-900" data-testid="settings-name">{admin?.full_name || 'Admin'}</h2>
            <p className="text-sm text-gray-500">{admin?.role?.replace('_', ' ')}</p>
          </div>
        </div>

        <div className="mt-6 space-y-4">
          <div className="flex items-center gap-3">
            <Mail className="w-4 h-4 text-gray-400" />
            <div>
              <p className="text-[11px] font-bold text-gray-400 uppercase tracking-wide">Email</p>
              <p className="text-sm font-semibold text-gray-900" data-testid="settings-email">{admin?.email}</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <User className="w-4 h-4 text-gray-400" />
            <div>
              <p className="text-[11px] font-bold text-gray-400 uppercase tracking-wide">Role</p>
              <p className="text-sm font-semibold text-gray-900">{admin?.role}</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <Shield className="w-4 h-4 text-gray-400" />
            <div>
              <p className="text-[11px] font-bold text-gray-400 uppercase tracking-wide">Permissions</p>
              <p className="text-sm font-semibold text-gray-900">{admin?.permissions?.join(', ') || '*'}</p>
            </div>
          </div>
          {admin?.last_login_at && (
            <div className="flex items-center gap-3">
              <Clock className="w-4 h-4 text-gray-400" />
              <div>
                <p className="text-[11px] font-bold text-gray-400 uppercase tracking-wide">Last Login</p>
                <p className="text-sm font-semibold text-gray-900">{dayjs(admin.last_login_at).format('MMM D, YYYY · h:mm A')}</p>
              </div>
            </div>
          )}
        </div>
      </div>

      <button
        data-testid="settings-logout-btn"
        onClick={handleLogout}
        className="w-full mt-4 flex items-center justify-center gap-2 bg-red-50 hover:bg-red-100 text-red-600 p-3.5 rounded-xl font-bold text-[15px] transition-colors"
      >
        <LogOut className="w-4 h-4" /> Log Out
      </button>
    </div>
  );
}
